import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import BlockUi from 'react-block-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowUp, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const StatsItem = ({ colorClassName, icon, label, tooltip, comparisonLabel, loading, valueFormatted, percentageChange,
	primaryLabel, secondaryLabel, secondaryValueFormatted, secondaryPercentageChange, t }) => {
	const hasDualValues = !!secondaryLabel;

	return <div className={'card widget-flat bg-white'} >
		<BlockUi blocking={loading}>
			<div className='card-body'>
				<div className={`float-right widget-icon rounded-circle ${colorClassName}`}>
					<FontAwesomeIcon icon={icon} />
				</div>
				<h5 className='text-uppercase text-nowrap mt-0 card-title'>{label}
					{tooltip && <OverlayTrigger placement='bottom' overlay={<Tooltip id='stats-tooltip'>{tooltip}</Tooltip>}>
						<FontAwesomeIcon icon={faCircleInfo} className='text-muted' style={{ fontSize: '14px', marginLeft: '6px', cursor: 'pointer' }} />
					</OverlayTrigger>}
				</h5>
				{hasDualValues ? <div style={{ display: 'flex', gap: '16px' }}>
					<div style={{ flex: 1 }}>
						<span className='text-muted text-uppercase' style={{ fontSize: '11px' }}>{primaryLabel}</span>
						<div><span className='text-black' style={{ fontSize: '20px' }}>{valueFormatted || <span>&nbsp;</span>}</span></div>
						{percentageChange ? <Badge className={`badge-light-lighten ${colorClassName}`} style={{ fontSize: '10px' }}>
							<FontAwesomeIcon icon={percentageChange > 0 ? faArrowUp : faArrowDown} /> {percentageChange}%</Badge> : <div style={{ height: '13px' }} />}
					</div>
					<div style={{ flex: 1 }}>
						<span className='text-muted text-uppercase' style={{ fontSize: '11px' }}>{secondaryLabel}</span>
						<div><span className='text-black' style={{ fontSize: '20px' }}>{secondaryValueFormatted || <span>&nbsp;</span>}</span></div>
						{secondaryPercentageChange ? <Badge className={`badge-light-lighten ${colorClassName}`} style={{ fontSize: '10px' }}>
							<FontAwesomeIcon icon={secondaryPercentageChange > 0 ? faArrowUp : faArrowDown} /> {secondaryPercentageChange}%</Badge> : <div style={{ height: '13px' }} />}
					</div>
				</div> : <div>
					<span className='mt-3 mb-3 text-black' style={{ fontSize: '24px' }}>{valueFormatted || <span>&nbsp;</span>}</span>
					<h5 className='mb-0'>
						{percentageChange ? <div>
							<Badge className={`badge-light-lighten mr-1 ${colorClassName}`}>
								<FontAwesomeIcon icon={percentageChange > 0 ? faArrowUp : faArrowDown} /> {percentageChange}%</Badge>
							<span className="text-nowrap" style={{ fontSize: '12px' }}>{comparisonLabel}</span>
						</div> : <div>&nbsp;</div>}
					</h5>
				</div>}
			</div>
		</BlockUi>
	</div>;
};

export default withTranslation()(StatsItem);